import React, { useState } from 'react';
import { array, bool, func } from 'prop-types';
import styled from 'styled-components';

import A11yContext from 'context/a11y-context';
import useWithA11y from 'library/hooks/use-with-a11y';
import ServiceProviderDetails from 'apps/journey/components/widgets/service-provider-widget/components/service-provider-details';
import BaseModal from 'library/components/base-modal';
import PlusSVG from 'library/icons/plus.svg';

const StyledClose = styled.div`
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  margin: 0.5em;
  font-size: 1.25em;
  transform: rotate(45deg);
`;

const StyledButton = styled.button`
  color: ${(props) => props.theme.colors.blue600};
  background-color: ${(props) => props.theme.colors.yellow300};
  border-color: ${(props) => props.theme.colors.yellow300};
  font-weight: bold;
  font-size: 1em;
  text-transform: unset;
  padding: 0.5em;
  height: 48px;

  :active,
  :focus {
    background-color: ${(props) => props.theme.colors.yellow500};
    border-color: ${(props) => props.theme.colors.yellow500};
  }
`;

const ModalStyle = {
  maxWidth: '680px',
  maxHeight: '770px',
};

const ServiceProviderModalToggle = ({ serviceProviders }) => {
  const [active, setActive] = useState(false);
  const { isTabbing } = useWithA11y();

  const toggleModal = () => {
    setActive(!active);
  };

  const handleKeyPressClose = (e) => {
    e.preventDefault();
    if (KeyCodes.POSITIVE_AFFIRMATIONS.includes(e.which)) {
      toggleModal();
    }
  };

  return (
    <>
      <StyledButton
        aria-label="Opens a modal to reveal more information about these service providers"
        onClick={toggleModal}
      >
        Learn More
      </StyledButton>
      {active && (
        <A11yContext.Provider value={{ isTabbing: isTabbing }}>
          <BaseModal
            active={active}
            toggleActive={toggleModal}
            modalStyle={ModalStyle}
          >
            <StyledClose
              tabIndex={0}
              aria-label="Close the modal"
              onKeyPress={handleKeyPressClose}
              onClick={toggleModal}
            >
              <PlusSVG />
            </StyledClose>
            <ServiceProviderDetails serviceProviders={serviceProviders} />
          </BaseModal>
        </A11yContext.Provider>
      )}
    </>
  );
};

ServiceProviderModalToggle.propTypes = {
  active: bool,
  toggleModal: func,
  serviceProviders: array,
};

ServiceProviderModalToggle.defaultProp = {
  serviceProviders: [],
};

export default ServiceProviderModalToggle;
